import React,{useState,useEffect} from 'react';
import Header from "../../component/Header";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../component/Loader";
import { Link,useHistory,useParams } from 'react-router-dom';
import Message from "../../component/Message";
import {toast,ToastContainer} from 'react-toastify'
import { resetpassword } from '../../Redux/action/stdAuth';

const ResetPassword = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const history = useHistory()
    const {loading,message,errorrrr} = useSelector(state => state.resetpasswordreducer)

    const [password,setpassword] = useState('')
    const [confirmPassword,setconfirmPassword] = useState('')

    const handlesubmit = (e) => {
        e.preventDefault()
        dispatch(resetpassword(password,confirmPassword,toast,params,history))
    }

    const handleChange = (e) => {
        const val = e.target.value
        const max = 3000
        const maxLength = max.toString().length-1
        const newVal = val < max ? val : parseInt(val.toString().substring(0, maxLength))
        console.log(newVal)
        setconfirmPassword(newVal)    
    }

    return(
<>
        <ToastContainer />
        <Header/>
        <main style={{display: 'flex',alignItems: 'center',justifyContent:'center',minHeight:'80vh'}}>
          
          <div class="form">
            <div class="heading">
              <h2>Reset Password</h2>
            </div>
        <form onSubmit={handlesubmit}>
              <label>
                <div class="icon">
                  <i class="fas fa-envelope"></i>
                </div>

                <input
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  type="password"
                  placeholder="password"
                />
              </label>
              <label>
                <div class="icon">
                  <i class="fas fa-envelope"></i>
                </div>

                <input
                  value={confirmPassword}
                  onChange={(e) => setconfirmPassword(e.target.value)}
                  type="password"
                  placeholder="confirm your password"
                />
              </label>
              {loading ? <Loader /> : <input type="submit" value="Reset Password" />}
              {/* <div style={{display:'flex',alignItems: 'center',justifyContent: 'center',marginTop:'10px'}}>
            <Link to="/stdLogin" style={{color:'green',textDecoration: "none",fontSize:'22px',fontWeight:'bold'}}>
              Back to Login Page
            </Link>
          </div> */}
              {errorrrr && <Message variant="danger">{message}</Message>}
              {message && <Message variant="success">{message}</Message>}
            </form>
          </div>
          </main>
          </>
    )
}

export default ResetPassword